import React, { useEffect } from "react";
import connectUserAndChat from "~/common/Store/connectUserAndChat";
import { User } from "~/common/Store/models/User";

interface Props {
  user: User;
  mounted: boolean;
}

function removeOpenGraphMetadata() {
  const nodeList = document.querySelectorAll('meta[property^="og:"]');
  nodeList.forEach((node: { remove: () => void }) => {
    node.remove();
  });
  document.querySelector('meta[property="fb:admins"]')?.remove();
}

const RemoveOpengraphMetadataFromDocument = connectUserAndChat(
  ({ user, mounted }: Props) => {
    useEffect(() => {
      if (mounted && user.registered) {
        removeOpenGraphMetadata();
      }
    });

    return <></>;
  },
);

export default RemoveOpengraphMetadataFromDocument;
